import { createI18n } from "vue-i18n";
import en from "./locales/en";
import zhTW from "./locales/zh-TW";

export type AppLocale = "en" | "zh-TW";

const savedLocale = localStorage.getItem("locale") as AppLocale | null;
const initialLocale: AppLocale =
  savedLocale === "zh-TW" || savedLocale === "en" ? savedLocale : "en";

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: "en",
  messages: {
    en,
    "zh-TW": zhTW,
  },
});

export default i18n;
